import { render, staticRenderFns } from "./BuildingListDetail.vue?vue&type=template&id=2de99b2e&scoped=true&"
import script from "./BuildingListDetail.vue?vue&type=script&lang=js&"
export * from "./BuildingListDetail.vue?vue&type=script&lang=js&"
import style0 from "./BuildingListDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BuildingListDetail.vue?vue&type=style&index=1&id=2de99b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de99b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de99b2e')) {
      api.createRecord('2de99b2e', component.options)
    } else {
      api.reload('2de99b2e', component.options)
    }
    module.hot.accept("./BuildingListDetail.vue?vue&type=template&id=2de99b2e&scoped=true&", function () {
      api.rerender('2de99b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/BuildingListDetail.vue"
export default component.exports